<template>
    <!-- exhibition-company-brand .ecb -->
    <div class="ecb">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem>企业中心</BreadcrumbItem>
                    <BreadcrumbItem>手机号配置</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">手机号配置</div>
            </div>
        </div>
        <div class="account-content">
            <div class="account-content-info">
                <div class="account-content-info-info1">
                    <div>
                        <p>更换绑定手机号</p>
                        <span v-if="adminInfo">已绑定手机号 {{ adminInfo.phoneNumber || '' }}</span>
                    </div>
                    <Button type="primary" style="width:96px;height:32px" @click="add = true">更换手机号</Button>
                </div>
            </div>
        </div>
        <Contact />
        <changePhone :show="add" @finish="init()" @close="add = false" />
    </div>
</template>

<script>
import Contact from "@components/Contact/Contact";
import changePhone from "./components/changePhone";
import { mapActions, mapGetters } from "vuex";

export default {
    // 账户安全
    name: "company-account",
    data() {
        return {
            add: false,
            add2: false,
            add3: false,
            formValidate: {
                name: "",
                job: "",
                tel: "",
                email: "",
                weixin: "",
            },
            adminInfo: null, // 管理员信息
        };
    },
    components: {
        Contact,
        changePhone,
    },
    computed: {
        ...mapGetters({
            user: "getUser",
            company: "loginModule/getCompany",
            exhibition: "loginModule/getExhibition",
        }),
    },
    created() {
        document.title = "中国国际医疗器械博览会 - 手机号配置";
        this.init();
    },
    methods: {
        ...mapActions({
            getUser: 'loginModule/getUser',
        }),
        async init() {
            let user = await this.getUser()
            console.log('userInfo', user)
            this.adminInfo = user
        },
    },
};
</script>

<style scoped lang="scss">
.account-content {
    width: 100%;
    height: auto;
    background-color: #f0f2f5;
    padding: 25px;

    &-info {
        min-width: 800px;
        background-color: #fff;

        &-info1 {
            height: 100px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 40px 0 45px;

            div {
                display: flex;
                align-items: center;

                p {
                    font-size: 16px;
                    font-weight: bold;
                }

                span {
                    font-size: 14px;
                    color: #8c8c8c;
                    margin-left: 30px;
                }
            }
        }
    }
}

.account-add {
    padding-top: 20px;

    &-title {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
        font-size: 16px;
    }

    &-content {
        .submit {
            display: flex;
            justify-content: center;

            button {
                margin-left: -75px;
            }
        }
    }
}
</style>